
import NavBar from './NavBar';  // Import the NavBar component
import {  Button, Card, Form,   Container, Row, Col } from "react-bootstrap";

import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import jsonData from "./data/data.json";
import jsonDataKab from "./data/datakab.json";
import UserTable from "./components/datatable/UserTable";
import UserTableKab from "./components/datatable/UserTableKab";
import StuntingDesc from "./components/datatable/StuntingDesc";
import UserChart from "./components/datatable/UserChart";


function Voicecommand({ asset, onClose, onRefresh }) {

  
  const [tab] = useState(useParams().tab);
  

  const [form, setForm] = useState({
    project_id: "",
    project_projectname: "",
  });

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const [arrowNavTab, setarrowNavTab] = useState("1");
  const arrowNavToggle = (tab) => {
    if (arrowNavTab !== tab) {
      setarrowNavTab(tab);
    }
  };

  const [activeTab, setactiveTab] = useState(tab);
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  // useEffect(() => {
  //   const fetchAssets = async () => {
  //     try {
  //       const response = await getAkunAll();
  //       setdataakun(response.data);
  //     } catch (err) {
  //       console.error("Error fetching assets:", err);
  //     }
  //   };
  //   fetchAssets();
  // }, [ids]);

  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [error, setError] = useState("");
  const recognitionRef = useRef(null); // Gunakan useRef untuk menyimpan instance recognition
  //const navigate = useNavigate();
  const [isTextBoxVisible, setIsTextBoxVisible] = useState(false);
  const [isDataKabupaten, SetIsDataKabupaten] = useState(false);
  const [isTeksKabupaten, SetIsTeksKabupaten] = useState(false);

  useEffect(() => {
    if ("webkitSpeechRecognition" in window || "SpeechRecognition" in window) {
      const SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition;

      const recognition = new SpeechRecognition();
      recognition.lang = "id-ID";
      recognition.interimResults = true;
      recognition.continuous = true;

      recognition.onresult = (event) => {
        const speechToText = Array.from(event.results)
          .map((result) => result[0].transcript)
          .join("");
        setTranscript(speechToText);

        if (speechToText.toLowerCase().includes("lakukan")) {
          const command = speechToText.toLowerCase();
          const actions = ["provinsi", "kabupaten", "grafik", "line", "map"];
          const action = actions.find((act) => command.includes(act));
          stopListening();

          switch (action) {
            case "provinsi":
              setIsTextBoxVisible(true);
              break;
            case "kabupaten":
              SetIsDataKabupaten(true);
              SetIsTeksKabupaten(true);
              break;

            case "grafik":
              alert("Chart?");
              break;

            case "line":
              alert("Line?");
              break;

            case "map":
              alert("Map?");
              break;

            default:
              console.log("No valid command found.");
              break;
          }
        }
      };

      recognition.onerror = (event) => {
        setError(`Error: ${event.error}`);
        stopListening();
      };

      recognitionRef.current = recognition; // Simpan instance ke useRef
    } else {
      setError("Your browser does not support Web Speech API.");
    }
  }, []); // Dependency array tetap kosong karena tidak ada variabel eksternal

  const formRef = useRef(null);

  const startListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.start();
      setTranscript("");
      setIsListening(true);
      setIsTextBoxVisible(false);

      SetIsDataKabupaten(false);
      SetIsTeksKabupaten(false);

      if (formRef.current) {
        const input = formRef.current.querySelector('input[name="username"]');
        if (input) {
          input.focus(); // Memindahkan fokus
        }
      }
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setIsListening(false);
    }
  };

  const executeAction = () => {
    alert("Perintah 'lakukan' terdeteksi! Menuju halaman lain...");    
  };

  document.title = "AI Report";  
  
  return (
    <>






          <div>
         <NavBar />      
    </div>
      <Container fluid style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ width: "100%", padding: "1rem" }} >
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                <h3>Analysis - Voice Command</h3>
                </Card.Header>
                <div style={{ width: "65%", padding: "1rem" }}>
                <Row >
                <Card.Body>
                  <Form>
                    <Row >
                      <Col md="12" >
                        <Form.Group>
                          <div style={{ textAlign: "left", padding: "10px" }}>
                            <p>Klik tombol untuk mulai mendengarkan, dan ucapkan "lakukan" untuk menjalankan aksi.</p>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-1" md="9">
                        <Form.Group>
                          <div>
                            <Form.Control type="text" value={transcript} name="username"></Form.Control>
                            {error && <p style={{ color: "red" }}>{error}</p>}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="3">
                        <Form.Group>
                          <Button onClick={startListening} disabled={isListening} className="btn btn-secondary " type="submit" variant="info">
                            {isListening ? "Listening..." : "Start Listening "}
                          </Button>
                          <Button onClick={stopListening} disabled={!isListening} style={{ marginLeft: "10px" }} class="btn btn-primary">
                            Stop
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div >
                      <Col md="12">Result :</Col>
                    </div>
                    {isTextBoxVisible && (
                      <Row>
                        <Col md="12">
                          <UserTable data={jsonData} />
                          <UserChart data={jsonData} />
                        </Col>
                      </Row>
                    )}
                    {isDataKabupaten && (
                      <Row>
                        <Col md="12">
                          <UserTableKab data={jsonDataKab} />
                        </Col>
                      </Row>
                    )}

                    {isTeksKabupaten && (
                      <Row>
                        <Col md="12">
                          <StuntingDesc data={jsonData} />
                        </Col>
                      </Row>
                    )}
                    <div className="clearfix" style={{ textAlign: "center", padding: "50px" }}></div>
                  </Form>
                </Card.Body>
                </Row>
                </div> 


              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default Voicecommand;





